import { locale } from '../lib/locale';

/** The "＋" menu (1.19). Glossary: „Einfach sagen“ = “Just say it”, Freizeit = Fun. */
export const ADD_TEXT = {
  de: {
    levels: { daily: 'Oft gebraucht', more: 'Seltener gebraucht' },
    options: {
      magic: {
        title: 'Einfach sagen',
        text: 'Tippen, sprechen oder ein Foto – die KI macht Vorschläge',
      },
      event: { title: 'Termin', text: 'Für alle oder bestimmte Personen' },
      shift: {
        title: 'Schicht- oder Stundenplan',
        text: 'Schichten im Rhythmus, Schul- und Kitazeiten',
      },
      job: { title: 'Aufgabe', text: 'Einmal oder regelmäßig, mit oder ohne Sterne' },
      shopping: { title: 'Einkauf', text: 'Auf die Einkaufsliste' },
      note: { title: 'Notiz', text: 'Zettel an der Pinnwand für alle' },
      kudos: { title: 'Familienmoment', text: 'Anerkennung mit Sternen' },
      reward: { title: 'Belohnung', text: 'Etwas, das man mit Sternen einlöst' },
      idea: { title: 'Ausflugsidee', text: 'Was wir mal machen wollen' },
      voucher: { title: 'Gutschein', text: 'Aus der Schublade – auch per Foto' },
      wish: { title: 'Wunsch', text: 'Auf den Wunschzettel' },
    },
    titles: {
      event: 'Neuer Termin',
      shift: 'Neuer Plan',
      magic: 'Einfach sagen',
      job: 'Neue Aufgabe',
      shopping: 'Einkaufsliste',
      note: 'Neue Notiz',
      reward: 'Neue Belohnung',
      kudos: 'Familienmoment für …',
      idea: 'Neue Ausflugsidee',
      voucher: 'Neuer Gutschein',
      wish: 'Neuer Wunsch',
    },
    ask: 'Was möchtest du hinzufügen?',
    magicExample: '„Freitag 17 Uhr Fußball für Ben, Papa fährt.“',
    orDirect: '… oder gezielt anlegen:',
    parentsAdd: 'Neue Dinge legen Mama oder Papa an. Sag ihnen einfach Bescheid!',
    wallHint: 'Mehr Möglichkeiten im Elternmodus',
    done: 'Fertig',
    whoseWishes: 'Für wessen Wunschzettel?',
    family: 'Familie',
  },
  en: {
    levels: { daily: 'Used often', more: 'Used less often' },
    options: {
      magic: {
        title: 'Just say it',
        text: 'Type, speak or take a photo – the AI makes suggestions',
      },
      event: { title: 'Event', text: 'For everyone or certain people' },
      shift: {
        title: 'Shift plan or timetable',
        text: 'Shifts in a rhythm, school and nursery times',
      },
      job: { title: 'Task', text: 'Once or regular, with or without stars' },
      shopping: { title: 'Shopping', text: 'Onto the shopping list' },
      note: { title: 'Note', text: 'A note on the pinboard for everyone' },
      kudos: { title: 'Family moment', text: 'Recognition with stars' },
      reward: { title: 'Reward', text: 'Something to redeem with stars' },
      idea: { title: 'Day-out idea', text: 'Something we’d like to do' },
      voucher: { title: 'Voucher', text: 'From the drawer – by photo too' },
      wish: { title: 'Wish', text: 'Onto the wish list' },
    },
    titles: {
      event: 'New event',
      shift: 'New plan',
      magic: 'Just say it',
      job: 'New task',
      shopping: 'Shopping list',
      note: 'New note',
      reward: 'New reward',
      kudos: 'Family moment for …',
      idea: 'New day-out idea',
      voucher: 'New voucher',
      wish: 'New wish',
    },
    ask: 'What would you like to add?',
    magicExample: '“Friday 5 pm football for Ben, Dad’s driving.”',
    orDirect: '… or add something specific:',
    parentsAdd: 'Mum or Dad add new things. Just let them know!',
    wallHint: 'More options in parent mode',
    done: 'Done',
    whoseWishes: 'Whose wish list?',
    family: 'Family',
  },
} as const;

export const addText = ADD_TEXT[locale];
